import { css } from '@emotion/react';

import { mediaquery } from 'shared/styles/styleFunctions';

export default (reverse: boolean) =>
  css({
    '.name-text-pairs': {
      flexDirection: reverse ? 'column-reverse' : 'column',
      alignItems: 'unset',
      [mediaquery.md]: {
        flexDirection: reverse ? 'row-reverse' : 'row',
        alignItems: 'baseline',
        gap: '16px',
      },
      '&__item': {
        width: '100%',
        marginBottom: '4px',
      },
      '&__header': {
        marginBottom: '0px',
        marginTop: '.5em',
      },
    },
  });
